export default __webpack_public_path__ + "static/media/Mark-2-HUD-06.4b4c058d.jpg";